import React, {Component} from 'react';
import {connect} from 'react-redux';

import DecorateContainer from '../../utils/DecoratedContainer';
import i18nLabels from './Footer.i18n';
import FooterMainView from './Footer.MainView';

const mapStateToProps = (state) => {
    return {
        i18nLabels,
        footerDetails: (state.headerFooter && state.headerFooter.footer) || null,
    };
};

class Footer extends Component {
    render() {
        return <FooterMainView {...this.props} />;
    }
}

export default connect(mapStateToProps, null)(DecorateContainer(Footer));
